export default function ClientDetails({ client }) {
  return [client.name, client.code].filter(Boolean).join(' - ');
}
